import { render, staticRenderFns } from "./RecipientContacts.vue?vue&type=template&id=021cba24"
import script from "./RecipientContacts.vue?vue&type=script&lang=js"
export * from "./RecipientContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports